import { ERoles } from '@/auth/constants';
import { BackkdropLoader } from '@/components/backdroploader';
import { PermWrapper } from '@/components/permwrapper';
import { Unauthorized } from '@/components/unauthorized';
import React from 'react';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';

const RegionCampaignsByRegion = React.lazy(
	() => import('@/views/settings/regioncampaigns/regions/main')
);
const RegionCampaignsByCampaign = React.lazy(
	() => import('@/views/settings/regioncampaigns/campaigns/main')
);

export const SettingsRoutes = (
	<>
		<Route
			path='/settings/regioncampaigns'
			element={
				<Suspense fallback={<BackkdropLoader />}>
					<PermWrapper
						allowedRoles={[
							ERoles.ADMIN,
							ERoles.SETTINGS_MANAGER,
							ERoles.SCHEDULE_READONLY
						]}
						fallback={<Unauthorized />}>
						<RegionCampaignsByRegion />
					</PermWrapper>
				</Suspense>
			}
		/>
		<Route
			path='/settings/campaigns'
			element={
				<Suspense fallback={<BackkdropLoader />}>
					<PermWrapper
						allowedRoles={[
							ERoles.ADMIN,
							ERoles.SETTINGS_MANAGER,
							ERoles.SCHEDULE_READONLY
						]}
						fallback={<Unauthorized />}>
						<RegionCampaignsByCampaign />
					</PermWrapper>
				</Suspense>
			}
		/>
	</>
);
